/** @jsx jsx */
import { jsx } from '@emotion/core';
import React, { useState, useEffect } from 'react';
import { Checkbox } from '@americanexpress/dls-react';
import PropTypes from 'prop-types';
import { getFormFields } from './AdvFormUtil';

const AdvAppFormItem = React.memo(({
  pageData, setPageData, acsMgmt, loginData,
}) => {
  const additionalDetailFieldswithValues = pageData.formFields.filter((data) => data.additionalDetail && data.value);
  const [displayAppForm, setDisplayAppForm] = useState(
    Array.isArray(additionalDetailFieldswithValues) && additionalDetailFieldswithValues.length > 0
  );

  useEffect(() => {
    setDisplayAppForm(
      Array.isArray(additionalDetailFieldswithValues) && additionalDetailFieldswithValues.length > 0
    );
  }, [additionalDetailFieldswithValues?.length]);

  const onCheckboxChange = () => {
    // resetting the values before unchecking the box
    if (displayAppForm) {
      const newPageData = { ...pageData };
      const appDetailList = pageData.formFields.filter((data) => Object.prototype.hasOwnProperty.call(data, 'additionalDetail') && data.additionalDetail);
      appDetailList.forEach((item) => {
        newPageData.formFields[item.id] = { ...newPageData.formFields[item.id], value: '' };
      });
      setPageData(newPageData);
    }
    setDisplayAppForm(!displayAppForm);
  };

  const appFormFields = getFormFields(pageData, setPageData, acsMgmt, loginData, true);
  return (
    <div>
      <div className="col-md-3" style={{ marginTop: '30px' }}>
        <Checkbox
          checked={displayAppForm}
          id="selectAppDetailCheckbox"
          label={<span>Search by Application Details</span>}
          name="selectAppDetailCheckboxSelection"
          onChange={onCheckboxChange}
        />
      </div>
      {displayAppForm && appFormFields}
    </div>
  );
});

AdvAppFormItem.displayName = 'AdvAppFormItem';

AdvAppFormItem.propTypes = {
  pageData: PropTypes.shape({
    formHeader: PropTypes.string,
    formFields: PropTypes.arrayOf(
      PropTypes.shape({
        value: PropTypes.string,
      })
    ),
  }),
  setPageData: PropTypes.func.isRequired,
  acsMgmt: PropTypes.node.isRequired,
  loginData: PropTypes.shape({}),
};

export default AdvAppFormItem;
